import { render, staticRenderFns } from "./Create-Services.vue?vue&type=template&id=2b077fb1"
import script from "./Create-Services.vue?vue&type=script&lang=js"
export * from "./Create-Services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports